export default __webpack_public_path__ + "static/media/tick-purple.5471941c.svg";